module.exports = {

			        "data" : {
              	"topCountries": [
	                {
	                  "code": "AUSTRALIA",
	                  "name": "AUSTRALIA"
	                },
	                {
	                  "code": "BELGIUM",
	                  "name": "BELGIUM"
	                },
	                {
	                  "code": "CANADA",
	                  "name": "CANADA"
	                },
	                {
	                  "code": "CHINA",
	                  "name": "CHINA"
	                },
	                {
	                  "code": "DENMARK",
	                  "name": "DENMARK"
	                },
	                {
	                  "code": "FRANCE",
	                  "name": "FRANCE"
	                },
	                {
	                  "code": "GERMANY",
	                  "name": "GERMANY"
	                },
	                {
	                  "code": "HONG KONG",
	                  "name": "HONG KONG"
	                },
	                {
	                  "code": "INDIA",
	                  "name": "INDIA"
	                },
	                {
	                  "code": "INDONESIA",
	                  "name": "INDONESIA"
	                },
	                {
	                  "code": "ITALY",
	                  "name": "ITALY"
	                },
	                {
	                  "code": "JAPAN",
	                  "name": "JAPAN"
	                },
	                {
	                  "code": "KUWAIT",
	                  "name": "KUWAIT"
	                },
	                {
	                  "code": "MALAYSIA",
	                  "name": "MALAYSIA"
	                },
	                {
	                  "code": "NETHERLANDS",
	                  "name": "NETHERLANDS"
	                },
	                {
	                  "code": "NEW ZEALAND",
	                  "name": "NEW ZEALAND"
	                },
	                {
	                  "code": "OMAN",
	                  "name": "OMAN"
	                },
	                {
	                  "code": "QATAR",
	                  "name": "QATAR"
	                },
	                {
	                  "code": "RUSSIA",
	                  "name": "RUSSIA"
	                },
	                {
	                  "code": "SAUDI ARABIA",
	                  "name": "SAUDI ARABIA"
	                },
	                {
	                  "code": "SINGAPORE",
	                  "name": "SINGAPORE"
	                },
	                {
	                  "code": "SPAIN",
	                  "name": "SPAIN"
	                },
	                {
	                  "code": "SWITZERLAND",
	                  "name": "SWITZERLAND"
	                },
	                {
	                  "code": "UAE",
	                  "name": "UAE"
	                },
	                {
	                  "code": "UK",
	                  "name": "UK"
	                },
	                {
	                  "code": "USA",
	                  "name": "USA"
	                },
	                {
	                  "code": "OTHER",
	                  "name": "OTHER"
	                }
              	],
              	"topStates": [
	                {
	                  "code": "ANI",
	                  "name": "ANDAMAN AND NICOBAR ISLANDS"
	                },
	                {
	                  "code": "AP",
	                  "name": "ANDHRA PRADESH"
	                },
	                {
	                  "code": "ARP",
	                  "name": "ARUNACHAL PRADESH"
	                },
	                {
	                  "code": "AS",
	                  "name": "ASSAM"
	                },
	                {
	                  "code": "BI",
	                  "name": "BIHAR"
	                },
	                {
	                  "code": "C",
	                  "name": "CHANDIGARH"
	                },
	                {
	                  "code": "CHH",
	                  "name": "CHHATTISGARH"
	                },
	                {
	                  "code": "DNH",
	                  "name": "DADRA AND NAGAR HAVELI"
	                },
	                {
	                  "code": "DND",
	                  "name": "DAMAN AND DIU"
	                },
	                {
	                  "code": "D",
	                  "name": "DELHI"
	                },
	                {
	                  "code": "GOA",
	                  "name": "GOA"
	                },
	                {
	                  "code": "GJ",
	                  "name": "GUJARAT"
	                },
	                {
	                  "code": "HA",
	                  "name": "HARYANA"
	                },
	                {
	                  "code": "HP",
	                  "name": "HIMACHAL PRADESH"
	                },
	                {
	                  "code": "JK",
	                  "name": "JAMMU AND KASHMIR"
	                },
	                {
	                  "code": "JHA",
	                  "name": "JHARKHAND"
	                },
	                {
	                  "code": "KA",
	                  "name": "KARNATAKA"
	                },
	                {
	                  "code": "KE",
	                  "name": "KERALA"
	                },
	                {
	                  "code": "LK",
	                  "name": "LAKSHADWEEP"
	                },
	                {
	                  "code": "MP",
	                  "name": "MADHYA PRADESH"
	                },
	                {
	                  "code": "MS",
	                  "name": "MAHARASHTRA"
	                },
	                {
	                  "code": "MA",
	                  "name": "MANIPUR"
	                },
	                {
	                  "code": "ME",
	                  "name": "MEGHALAYA"
	                },
	                {
	                  "code": "MI",
	                  "name": "MIZORAM"
	                },
	                {
	                  "code": "NA",
	                  "name": "NAGALAND"
	                },
	                {
	                  "code": "OR",
	                  "name": "ORISSA"
	                },
	                {
	                  "code": "PO",
	                  "name": "PONDICHERRY"
	                },
	                {
	                  "code": "PJ",
	                  "name": "PUNJAB"
	                },
	                {
	                  "code": "RJ",
	                  "name": "RAJASTHAN"
	                },
	                {
	                  "code": "SKM",
	                  "name": "SIKKIM"
	                },
	                {
	                  "code": "TN",
	                  "name": "TAMIL NADU"
	                },
	                {
	                  "code": "TL",
	                  "name": "TELANGANA"
	                },
	                {
	                  "code": "TR",
	                  "name": "TRIPURA"
	                },
	                {
	                  "code": "UP",
	                  "name": "UTTAR PRADESH"
	                },
	                {
	                  "code": "UTT",
	                  "name": "UTTARANCHAL"
	                },
	                {
	                  "code": "WB",
	                  "name": "WEST BENGAL"
	                }
              ]
            }
}